import { Calendar } from 'lucide-react';
import React, { PropsWithChildren } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface DatePickerComponentProps {
  selectedDate: Date | null;
  handleDateChange: (date: Date | null) => void;
  isMobile: boolean;
  portalId: string;
  container: HTMLElement | null;
  colors?: {
    dateBackground?: string;
    dateBorder?: string;
    dateText?: string;
    selectedDateBackground?: string;
    selectedDateBorder?: string;
    selectedDateText?: string;
    iconColor?: string;
    [key: string]: string | undefined;
  };
}

const DatePickerComponent: React.FC<DatePickerComponentProps> = ({
  selectedDate,
  handleDateChange,
  isMobile,
  portalId,
  container,
  colors = {}
}) => {
  React.useEffect(() => {
    // Create portal container if it doesn't exist
    if (!document.getElementById(portalId)) {
      const portalElement = document.createElement('div');
      portalElement.id = portalId;
      document.body.appendChild(portalElement);
    }
  }, [portalId]);

  const CustomPopperContainer = ({ children }: PropsWithChildren) => (
    <div id={portalId}>
      {isMobile ? (
        <div className="lp-fixed lp-inset-0 lp-bg-black/50 lp-flex lp-items-center lp-justify-center lp-z-[9999]">
          <div className="lp-w-[300px] lp-bg-transparent" onClick={e => e.stopPropagation()}>
            {children}
          </div>
        </div>
      ) : children}
    </div>
  );

  return (
    <div className="lp-relative lp-mb-6">
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        dateFormat="yyyy-MM-dd"
        minDate={new Date()}
        className="lp-w-full lp-backdrop-blur-sm lp-rounded-xl lp-p-3 lp-pl-10 focus:lp-outline-none focus:lp-ring-1 lp-transition-all lp-duration-200"
        //@ts-expect-error
        style={{
          backgroundColor: colors.dateBackground || '#000000B3',
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: colors.dateBorder || '#DDB88919',
          color: colors.dateText || '#DDB889',
        }}
        calendarClassName="lp-react-datepicker"
        popperClassName="lp-react-datepicker-popper"
        dayClassName={date => {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return date < today
            ? "lp-text-gray-500 lp-opacity-50 lp-cursor-not-allowed"
            : "hover:lp-bg-[#DDB889]/10 lp-rounded-full"
        }}
        popperPlacement="bottom-start"
        popperContainer={CustomPopperContainer}
        withPortal={isMobile}
      />
      <Calendar
        className="lp-absolute lp-left-3 lp-top-1/2 lp-transform -lp-translate-y-1/2"
        size={16}
        color={colors.iconColor || '#DDB889'}
      />
    </div>
  );
};

export default DatePickerComponent;
